import React from 'react';

export default function PersonalTab({ selectedUser, updateSelectedUserField, savePersonalInfo }) {
  if (!selectedUser) return null;

  return (
    <div>
      {/* Personal Info Card */}
      <div className="pr-card">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 18 }}>
          {/* Avatar */}
          <div style={{
            width: 52, height: 52, borderRadius: '50%',
            background: 'linear-gradient(135deg, #6C5CE7, #a29bfe)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 800, fontSize: '1.2rem', marginRight: 16,
          }}>
            {(selectedUser.username || selectedUser.fullName || '?').slice(0, 2).toUpperCase()}
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: '1.05rem', color: '#2d3436' }}>
              {selectedUser.username || selectedUser.fullName || selectedUser.name}
            </div>
            <div style={{ fontSize: '0.78rem', color: '#636e72', marginTop: 2 }}>
              {(selectedUser.roles && selectedUser.roles.join(', ')) || 'Staff'}
            </div>
          </div>
        </div>

        <div className="pr-card-header">Basic Information</div>

        <div className="pr-two-col">
          <div className="pr-form-group">
            <label className="pr-label">Full Name</label>
            <input
              className="pr-input"
              type="text"
              value={selectedUser.username || ''}
              readOnly
            />
          </div>

          <div className="pr-form-group">
            <label className="pr-label">Phone Number</label>
            <input
              className="pr-input"
              type="text"
              value={selectedUser.number || ''}
              readOnly
            />
          </div>

          <div className="pr-form-group">
            <label className="pr-label">Email Address</label>
            <input
              className="pr-input"
              type="email"
              value={selectedUser.email || ''}
              onChange={function (e) { updateSelectedUserField('email', e.target.value); }}
              placeholder="employee@example.com"
            />
          </div>

          <div className="pr-form-group">
            <label className="pr-label">Date of Joining</label>
            <input
              className="pr-input"
              type="date"
              value={selectedUser.joiningDate ? selectedUser.joiningDate.slice(0, 10) : ''}
              onChange={function (e) { updateSelectedUserField('joiningDate', e.target.value); }}
            />
          </div>
        </div>
      </div>

      {/* Bank Details Card */}
      <div className="pr-bank-card">
        <div className="pr-card-header" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 8, fontSize: '1rem' }}>🏦</span>
          Bank Details
        </div>

        <div className="pr-two-col">
          <div className="pr-form-group">
            <label className="pr-label">Account Number</label>
            <input
              className="pr-input"
              type="text"
              value={selectedUser.bacct || ''}
              onChange={function (e) { updateSelectedUserField('bacct', e.target.value); }}
              placeholder="Enter account number"
            />
          </div>

          <div className="pr-form-group">
            <label className="pr-label">IFSC Code</label>
            <input
              className="pr-input"
              type="text"
              value={selectedUser.bifsc || ''}
              onChange={function (e) { updateSelectedUserField('bifsc', e.target.value); }}
              placeholder="e.g. SBIN0001234"
            />
          </div>

          <div className="pr-form-group">
            <label className="pr-label">Bank Name</label>
            <input
              className="pr-input"
              type="text"
              value={selectedUser.bname || ''}
              onChange={function (e) { updateSelectedUserField('bname', e.target.value); }}
              placeholder="e.g. State Bank of India"
            />
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
        <button className="pr-btn teal" onClick={savePersonalInfo}
          style={{ padding: '12px 28px', fontSize: '0.88rem' }}>
          Save Personal Info
        </button>
      </div>
    </div>
  );
}
